import React from "react";
import config from "../config";
import { RaisedButton } from "material-ui";
import qs from "qs";

import PassTable from "./partials/pass-table.jsx";

import BackButton from "./partials/back-button.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PassBucketActions from "../actions/PassBucketActions";
import PassBucketStore from "../stores/PassBucketStore";
import PassActions from "../actions/PassActions";
import PassStore from "../stores/PassStore";
import UserStore from "../stores/UserStore";
import EventBucketStore from "../stores/EventBucketStore";
import DownloadPassBucketCsvButton from "./partials/download-pass-bucket-csv-button.jsx";

class PassBucket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetchingPassBucket: false,
      fetchedPassBucket: null
    };

    this._makeDirectSalesLink = this._makeDirectSalesLink.bind(this);
  }

  static getStores() {
    return [PassBucketStore, PassStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      getPassBucketById: PassBucketStore.getPassBucketById,
      getPassesForPassBucket: PassStore.getPassesForPassBucket,
      apiKey: UserStore.getState().apiKey,
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  _makeDirectSalesLink() {
    let eventBucket = this.props.getEventBucketById(
        this.props.params.eventBucketId
      ),
      passBucket = this.props.getPassBucketById(this.props.params.passBucketId);

    return (
      eventBucket &&
      passBucket &&
      `${eventBucket.urls.buy_passes}/${passBucket.code}`
    );
  }

  getStyles() {
    return {};
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var passBucket = newProps.getPassBucketById(newProps.params.passBucketId);

    if (
      !this.state.isFetchingPassBucket &&
      this.state.fetchedPassBucket !== newProps.params.passBucketId
    ) {
      PassBucketActions.fetchOne(newProps.params.passBucketId);
      PassActions.fetchAllForPassBucket(newProps.params.passBucketId);
      this.setState({ isFetchingPassBucket: true });
    } else if (passBucket) {
      this.setState({
        isFetchingPassBucket: false,
        fetchedPassBucket: passBucket.id
      });
    }
  }

  render() {
    var styles = this.getStyles(),
      passBucket = this.props.getPassBucketById(this.props.params.passBucketId),
      passes = this.props.getPassesForPassBucket(
        this.props.params.passBucketId
      );

    if (!passBucket) {
      return null;
    }

    return (
      <div>
        <h1>
          {passBucket.name}{" "}
          <span style={{ fontWeight: "normal", fontSize: "0.6em" }}>
            {passes.length} pass{passes.length === 1 ? "" : "es"} issued
          </span>{" "}
          {passes.some(p => p.pass_subscription) ? (
            <span style={{ fontWeight: "normal", fontSize: "0.6em" }}>
              |{" "}
              {
                passes.filter(
                  p =>
                    p.pass_subscription &&
                    p.pass_subscription.status === "active"
                ).length
              }{" "}
              currently active{" "}
            </span>
          ) : null}
          <span style={{ fontWeight: "normal", fontSize: "0.6em" }}>
              |{" "}
              {
                passBucket.unlimited
                  ? "unlimited passes available"
                  : `${passBucket.quantity - passBucket.quantity_sold} passes available`
              }
          </span>
        </h1>
        <div style={{ margin: "10px 0 20px" }}>
          <BackButton
            label={"pass buckets"}
            style={{ marginRight: 7, verticalAlign: "middle" }}
            onTouchTap={() =>
              this.props.location.state && this.props.location.state.fromListing
                ? this.context.router.goBack()
                : this.context.router.push(
                    `/event_buckets/${this.props.params.eventBucketId}/pass_buckets`
                  )
            }
          />
          {UserStore.hasPermission("edit_pass_bucket") ? (
            <RaisedButton
              style={{ marginRight: 7, verticalAlign: "middle" }}
              label="Settings"
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${this.props.params.eventBucketId}/pass_buckets/${this.props.params.passBucketId}/edit`
                )
              }
            />
          ) : null}
          <DownloadPassBucketCsvButton
            style={{ marginRight: 7, verticalAlign: "middle" }}
            label="More ▾"
            passBucketId={passBucket.id}
            additionalOptions={[
              {
                href: this._makeDirectSalesLink(),
                label: "Direct customer sales link"
              }
            ]}
          />
        </div>
        <PassTable
          passes={passes}
          eventBucket={this.props.params.eventBucketId}
          hidePassBucket={true}
          location={this.props.location}
        />
      </div>
    );
  }
}

export default connectToStores(PassBucket);



// WEBPACK FOOTER //
// ./src/app/components/pass-bucket.jsx